import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=7a95b414&"
import script from "./patients.vue?vue&type=script&lang=js&"
export * from "./patients.vue?vue&type=script&lang=js&"
import style0 from "./patients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports